import { setListener } from "@front/utils";

const submit = document.querySelector('.js-customer-submit') as HTMLElement;

if(submit) {
    setListener(submit, 'click', () => {
        const alertPassword = document.querySelector('.js-alert-password') as HTMLElement;
        const alertConfidential = document.querySelector('.js-alert-confidential') as HTMLElement;
        const password = document.querySelector('.js-password-create') as HTMLInputElement;
        const confidential = document.querySelector('.js-confidential-input') as HTMLInputElement;
        confidential.checked ? alertConfidential.classList.add('hidden') : alertConfidential.classList.remove('hidden');
        password.value.length < 5 ? alertPassword.classList.remove('hidden') : alertPassword.classList.add('hidden');
    });
}